function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlertRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.82 25.94L17.25 3.72a1.45 1.45 0 00-2.5 0L2.18 25.94A1.39 1.39 0 003.43 28h25.14a1.39 1.39 0 001.25-2.06zM16 24a1.86 1.86 0 01-1.36-.55 1.878 1.878 0 010-2.7 1.89 1.89 0 011.36-.54 1.93 1.93 0 011.37.54 1.881 1.881 0 010 2.7A1.89 1.89 0 0116 24zm-1.26-5.29l-.2-8.71h3l-.24 8.71h-2.56z",
    fill: props.color
  }));
}

export default SvgIconAlertRexFilled;